'use client';

import { useCallback, useSyncExternalStore } from 'react';

const server = () => null;
const subscribe = (notify: () => void) => {
  window.addEventListener('storage', notify);
  window.addEventListener('focus', notify);
  return () => { window.removeEventListener('storage', notify); window.removeEventListener('focus', notify); };
};

export function useBrowserStorageValue(key: string): string | null {
  const snapshot = useCallback(() => {
    try { return window.localStorage.getItem(key); } catch { return null; }
  }, [key]);
  return useSyncExternalStore(subscribe, snapshot, server);
}
